/**
 * What Tenant Detail says after its product switch answered.
 *
 * The switch posts to the control-plane route
 * (`POST /control-plane/tenants/{id}/modules/{code}/enable|disable`), which
 * runs the same toggle as the Products page. Switching a product off also
 * switches its add-ons off (DocFlow takes Cluvik CRM Connector with it), and
 * when that part fails the route answers `result: completed_with_failures`
 * with the remedy in `message` (A-2). The module change itself did land, so
 * this is a WARNING, not an error, and it must not read as a plain success.
 *
 * `success` and an absent `result` keep the existing text: a code the
 * Products list does not name is served without the toggle and carries no
 * result at all.
 */
export const COMPLETED_WITH_FAILURES = 'completed_with_failures';

export const moduleToggleOutcome = (data, { label, wasEnabled } = {}) => {
  const done = `${label} ${wasEnabled ? 'disabled' : 'enabled'}`;
  if (data?.result === COMPLETED_WITH_FAILURES) {
    return {
      tone: 'warning',
      text: data.message
        || `${done}, but not everything it changes was applied. Save again to finish.`,
    };
  }
  return { tone: 'success', text: done };
};
